import {
  logException as commonLogException,
  Context,
  Exception,
  LogException,
} from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { SEVERITY_LEVEL } from '@savgroup-front-common/constants/shared';
import { useLoginStore } from '@savgroup-front-common/core/domains/login/useLoginStore';

function logException(
  { error, severityLevel = SEVERITY_LEVEL.ERROR }: LogException,
  context: Context = {},
) {
  const { login } = useLoginStore.getState();

  const extendedContext = {
    ...context,
    userInfos: {
      userId: login?.userId,
      mail: login?.mail,
    },
  };

  commonLogException({ error, severityLevel }, extendedContext);
}

export function logWarning(error: Exception, context: Context = {}) {
  logException({ error, severityLevel: SEVERITY_LEVEL.WARNING }, context);
}

export function logError(error: Exception, context: Context = {}) {
  logException({ error, severityLevel: SEVERITY_LEVEL.ERROR }, context);
}

export function logCritical(error: Exception, context: Context = {}) {
  logException({ error, severityLevel: SEVERITY_LEVEL.CRITICAL }, context);
}

export function logVerbose(error: Exception, context: Context = {}) {
  logException({ error, severityLevel: SEVERITY_LEVEL.VERBOSE }, context);
}
